import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../modules/modal/modal-ref";
import {first, switchMap, filter} from "rxjs/operators";
import {Website} from "../../../websites/website/website";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../store';
import {Router} from "@angular/router";
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../../user/user-subscription";
import {HostingService} from "../../../websites/website/hosting/hosting.service";
import {Utils} from "../../../shared/utils/utils";
import {combineLatest} from "rxjs";
import {User} from "../../../user/user";
import * as userActions from "../../../store/actions/user.action";
import {Config} from "../../../config/config";

@Component({
    selector: 'db-create-website-success',
    templateUrl: './create-website-success.component.html',
    styleUrls: ['./create-website-success.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CreateWebsiteSuccessComponent implements OnInit {

  @Input() website: Website;
  @Input() nameservers?: string[];
  @Input() isClone = false;

  public steps: string[] = [
    'text_buildOrGenerateWebsite',
    'text_editWithDragDrop',
    'text_successAfterDemoUpgradeBullet3',
    'text_connectDomain'
  ];
  public userSubscription: UserSubscription;
  public user: User;
  public isCopied: any = [];
  public companyName: string = 'Dashboard';

  constructor(
    private readonly _activeModal: DbActiveModal,
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly _router: Router,
    private readonly _hostingService: HostingService,
  ) { }

  ngOnInit() {
    this._store.dispatch(new fromStore.LoadWebsites());
    this._store.dispatch(new userActions.LoadUserSubscription());
    this._resizeModal();
    this._getUserAndUserSubscription();
    this._getCompanyInfo();
  }

  private _resizeModal(): void {
    if (this.website && this.website.score && this.website.score.currentScore && this.website.score.currentScore.desktopScore) {
      this._activeModal.resize(null, 700);
    }
  }

  private _getUserAndUserSubscription(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        first(loaded => loaded),
        switchMap(() => combineLatest(
          this._store.select(fromStore.getUser),
          this._store.select(fromStore.getUserSubscription),
        ))
      )
      .pipe(first(([user, userSubscription]) => !!user && !!userSubscription))
      .subscribe(([user, userSubscription]) => {
        this.userSubscription = userSubscription;
        this.user = user;
        const _agreementDayDiff = Utils.getDaysDiffFromToday(this.userSubscription?.agreementDate, false);
        if (+_agreementDayDiff < 8) {
          ((this.user && this.user.isSuspected) || this.website) && !this.website?.isAiBuilderDemo && this._hostingService.whiteListIp(this.website.id, this.website.site_url);
        }
      });
  }

  public closeModal(): void {
    if (this.website && this.website.id) {
      this._router.navigateByUrl(`/websites/${this.website.id}/main`);
      this._activeModal.close();
    }
  }

  public copiedNameServer(index: number) {
    this.isCopied[index] = true;
    setTimeout( () => this.isCopied[index] = false, 800);
  }

  private _getCompanyInfo(): void {
    this._store.select(fromStore.getCompanyInfoLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getCompanyInfo)),
        first()
      )
      .subscribe((companyInfo: any) => {
        this.companyName = companyInfo?.branding?.company_name || companyInfo?.agency?.name || 'YourBrand';
      });
  }
}
